<template>
    <v-card>

        <v-card-title>
            <div class="title font-weight-light">Finalizar Atención</div>
        </v-card-title>

        <v-card-text>
            <v-select
                    v-model="derivationType"
                    label="Selecciona una opción"
                    :items="derivationOptions" />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed @click="$emit('cancel')">Cancelar</v-btn>
            <v-btn depressed
                   @click="confirm"
                   :loading="loading"
                   color="primary">Confirmar</v-btn>
        </v-card-actions>

    </v-card>
</template>

<script>
    export default{
        props:{
            event: {
                type: Object
            },
            loading:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                derivationType: 'discharge'
            }
        },
        methods:{
            confirm(){
                var vm = this
                vm.$emit('confirm', {
                    derivation: {
                        type: vm.derivationType
                    }
                })
            }
        },
        computed:{
            derivationOptions(){
                var vm = this

                const dischargeLabel = vm.psychologicalRecord && vm.psychologicalRecord.session_number === 0 ?
                        'No requiere terapia' : 'Dar de alta'

                const controlLabel = vm.psychologicalRecord && vm.psychologicalRecord.session_number === 0 ?
                        'Requiere terapia' : 'Continuar con terapia'

                return [
                    {
                        value: 'control',
                        text: controlLabel
                    },
                    {
                        value: 'discharge',
                        text: dischargeLabel
                    }
                ]
            },
            psychologicalRecord(){
                var vm = this
                return vm.event && vm.event.psychological_record || null
            }
        }
    }
</script>